/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import L from "../Lang"
import BaseCom from "../BaseCom";
import FormInput from "../FormInput";
import { withParamsAndNavigate } from "../WithParamsAndNavigate";

class LabRequest extends BaseCom {
    constructor(props) {
        super(props);
        this.state = {
            info: {},
            list: [],
            selected: []
        }
    }

    async componentDidMount() {
        if(Array.isArray(this.props.currentValues))
            this.setState({ selected: this.props.currentValues });
    }
    
    componentDidUpdate(prevProps) {
        if(this.props.currentValues !== prevProps.currentValues) {
            if(Array.isArray(this.props.currentValues))
                this.setState({ selected: this.props.currentValues });
        }
    }

    changeLab = (v) => {
        
    }

    render() {
        return (
            <div>
                <FormInput model={this.state.info}
                    labelAsPlaceholder
                    name="labID"
                    label="Laboratory"
                    type="select"
                    options={this.state.labs || []}
                    onChange={this.changeLab}
                    />
            </div>
        )
    }
}

export default withParamsAndNavigate(LabRequest);